import React from "react";
import Controlling from "./Controlling.jsx";
import ProjectNetworkManager from "./ProjectNetworkManager.jsx";
import ProjectRates from "./ProjectRates.jsx";
import Plans from "./Plans.jsx";
import Sitzungen from "./Sitzungen.jsx";
import ProjectWebsite from "./ProjectWebsite.jsx";
import GatoodleTab from "./Gatoodle/GatoodleTab.jsx";

import "../styles/_project-page.scss";

const ProjectPage = ({ project, employees, activeTab, setActiveTab, readOnly = false }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("de-CH", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("de-CH", {
      style: "currency",
      currency: "CHF",
    }).format(amount);
  };


  return (
    <div className="project-page-content">
      {activeTab === "info" && (
        <div className="project-info-tab">
          {project.image && (
            <div className="project-image">
              <img src={project.image} alt={project.title} />
            </div>
          )}

          <div className="project-info-grid">
            {(project.projektstart || project.projektende) && (
              <div className="info-card">
                <h3>Zeitraum</h3>
                <div className="timeline">
                  {project.projektstart && (
                    <div className="timeline-item">
                      <label>Projektstart:</label>
                      <span>{formatDate(project.projektstart)}</span>
                    </div>
                  )}
                  {project.projektende && (
                    <div className="timeline-item">
                      <label>Projektende:</label>
                      <span>{formatDate(project.projektende)}</span>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Standort */}
            {project.adresse && (
              <div className="info-card">
                <h3>Standort</h3>
                <div className="location-address">
                  <label>Adresse: </label>
                  <span>{project.adresse}</span>
                </div>
              </div>
            )}

            {/* Finanzinformationen */}

            {project.description && (
              <div className="info-card">
                <h3>Beschreibung</h3>
                <p>{project.description}</p>
              </div>
            )}

            {(project.baukosten || project.honorar) && (
              <div className="info-card">
                <h3>Finanzen</h3>
                <div className="finances">
                  {project.baukosten && (
                    <div className="finance-item">
                      <label>Baukosten:</label>
                      <span>{formatCurrency(project.baukosten)}</span>
                    </div>
                  )}
                  {project.honorar && (
                    <div className="finance-item">
                      <label>Honorar:</label>
                      <span>{formatCurrency(project.honorar)}</span>
                    </div>
                  )}
                  {project.baukosten && project.honorar && (
                    <div className="finance-item">
                      <label>Honorar-Prozentsatz:</label>
                      <span>
                        {((project.honorar / project.baukosten) * 100).toFixed(
                          1
                        )}
                        %
                      </span>
                    </div>
                  )}
                </div>
              </div>
            )}

            {project.tags?.length > 0 && (
              <div className="info-card">
                <h3>Tags</h3>
                <div className="tags-display">
                  {project.tags.map((tag, index) => {
                    const tagName = typeof tag === "object" ? tag.name : tag;
                    const tagColor =
                      typeof tag === "object" ? tag.color : "#6c757d";
                    return (
                      <span
                        key={typeof tag === "object" ? tag.id : `tag-${index}`}
                        className="tag-badge"
                        style={{ backgroundColor: tagColor }}
                      >
                        {tagName || "Unbekannt"}
                      </span>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {activeTab === "netzwerk" && (
        <ProjectNetworkManager
          project={project}
          onClose={() => setActiveTab("info")}
        />
      )}

      {activeTab === "controlling" && (
        <div className="content-area">
          <Controlling
            project={project}
            projectCode={project.code}
            employees={employees}
            isInline={true}
            readOnly={readOnly}
          />
        </div>
      )}

      {activeTab === "ansaetze" && (
        <div className="content-area">
          <ProjectRates
            project={project}
            projectCode={project.code}
            readOnly={readOnly}
          />
        </div>
      )}

      {activeTab === "plaene" && (
        <div className="content-area">
          <Plans project={project} readOnly={readOnly} />
        </div>
      )}

      {activeTab === "sitzungen" && (
        <div className="content-area">
          <Sitzungen project={project} readOnly={readOnly} />
        </div>
      )}

      {activeTab === "website" && (
        <div className="content-area">
          <ProjectWebsite project={project} readOnly={readOnly} />
        </div>
      )}

      {activeTab === "gatoodle" && (
        <div className="content-area">
          <GatoodleTab readOnly={readOnly} />
        </div>
      )}

    </div>
  );
};

export default ProjectPage;
